import BaseNormalizer from "./BaseNormalizer";

const shippingUnitNormalizer = Object.create(BaseNormalizer).init([
  "id",
  "state",
  "name",
  "gtin",
  "promotionType",
  "supplierItemNumber",
  "purchasePrice",
  "dimensionWidthCm",
  "dimensionHeightCm",
  "dimensionLengthCm",
  "weightKg",
  "weightExclPackagingKg",
  "orderableFrom",
  "orderableTo",
  "packagingId",
  "depositValue",
  "depositTypeId",
  "isEditable",
  "isLive",
  "imageId",
  "thumbnailUri",
  "rejectionReason",
  "quantity",
]);

export default shippingUnitNormalizer;
